import throttle from 'lodash.throttle';
import debounce from 'lodash.debounce';

/* eslint-disable */

/**
 * Polyfill position:sticky
 *
 * @param {Object} stickyEl     Element to be made sticky.
 * @param {Object} stickyStyles Imported styles (.stick, .scroll)
 */
class PositionSticky {

  constructor(
    stickyEl,
    stickyStyles
  ) {
    // Required parameters
    this.body        = document.querySelector('body');
    this.initialized = false;
    this.stickyClass = stickyStyles.stick;
    this.stickyEl    = stickyEl;
    this.timeout     = false;
    // Listeners
    window.addEventListener(
      'scroll',
      throttle((e) => this.toggleSticky.call(this, e.type), 150)
    );
    window.addEventListener(
      'resize',
      debounce((e) => this.toggleSticky.call(this, e.type), 250)
    );
  }

  hasStickyClass() {
    return this.stickyEl.classList.contains(this.stickyClass);
  }

  stickElement() {
    if (! this.hasStickyClass()) {
      this.body.classList.add(this.stickyClass);
      this.stickyEl.classList.add(this.stickyClass);
    }
  }

  unstickElement() {
    if (this.hasStickyClass()) {
      this.stickyEl.classList.remove(this.stickyClass);
      this.body.classList.remove(this.stickyClass);
    }
  }

  toggleSticky(event) {
    if (this.stickyEl) {

      // Get fresh values on resize or initialization
      if ('resize' === event || ! this.initialized) {
        this.unstickElement();
        this.scrollPos         = document.body.scrollTop
          || document.documentElement.scrollTop;
        this.stickyElRect      = this.stickyEl.getBoundingClientRect();
        this.stickyElHeight    = this.stickyElRect.height;
        this.stickyElTopOffset = this.stickyElRect.height;
        this.initialized       = true;
      }

      // Get scroll position
      const windowTop = (
        document.body.scrollTop
        || document.documentElement.scrollTop
      );

      // Scrolled past top of sticky element
      if (
        windowTop > this.stickyElHeight
        && document.body.clientHeight > this.stickyElHeight
      ) {
        this.stickElement();
      } else {
        this.unstickElement();
      }

    } else {
      this.unstickElement();
    }
  }
}

export { PositionSticky as default };
